import React, { Component } from "react";
import { Paper } from "@material-ui/core";
import { PatientDTO } from "../../../dto/patient";
import LabChart from "../../components/LabChart";
import PatientBanner from "../../../patient/components/PatientBanner";

interface Hba1cChartProps {
  location: {
    state: {
      nameStr: string;
      ptObj: PatientDTO;
    };
  };
}

interface Hba1cChartState {}

class Hba1cChart extends Component<Hba1cChartProps, Hba1cChartState> {
  state: Readonly<Hba1cChartState> = {};

  render() {
    return (
      <div>
        <Paper>
          <PatientBanner
            title="Lab Detail for"
            nameStr={this.props.location.state.nameStr}
            patient={this.props.location.state.ptObj}
          />
          <LabChart test="hba1c" pid={this.props.location.state.ptObj.id} />
        </Paper>
      </div>
    );
  }
}

export default Hba1cChart;
